export default __webpack_public_path__ + "static/media/global-mba-graduation-conversation-v1.fc9fefe0.jpg";